import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, BrowserRouter, Routes } from "react-router-dom";
import './index.css';

import Home from './components/Home';
import DataScience from './components/DataScience';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Routes>
        <Route path="/ramonportfolio" element={<Home />} />
        <Route path="/ramonportfolio/DataScience" element={<DataScience />}></Route>
        </Routes>
    </BrowserRouter>
);


